import { ResponsiveContainer, Tooltip, PieChart, Pie, Cell } from "recharts";

const COLORS = [
  "#6f8fb3",
  "#72a3a0",
  "#8fa67b",
  "#9a90b8",
  "#b69383",
  "#7899ad",
  "#a89b72",
  "#8a9f91",
  "#9b93a4",
  "#7ea3bb",
  "#a57e94",
  "#8e9c75",
];

const DefectCodesChart = ({
  data,
  selectedId = null,
  onSelect,
  horizontal = false,
}) => {
  return (
    <div className={horizontal ? "flex items-center gap-4" : ""}>
      <div className={horizontal ? "w-48 flex-shrink-0" : ""}>
        <ResponsiveContainer width="100%" height={220}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={68}
              label={data.length <= 5}
              labelLine={data.length <= 5}
              dataKey="value"
              onClick={
                onSelect
                  ? (entry) =>
                      onSelect(entry.id === selectedId ? null : entry.id)
                  : undefined
              }
            >
              {data.map((item, index) => (
                <Cell
                  key={item.id}
                  fill={COLORS[index % COLORS.length]}
                  fillOpacity={
                    selectedId === item.id
                      ? 1
                      : selectedId === null
                        ? 0.75
                        : 0.25
                  }
                  stroke={selectedId === item.id ? "#334155" : "none"}
                  strokeWidth={selectedId === item.id ? 2 : 0}
                  style={onSelect ? { cursor: "pointer" } : undefined}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div
        className={`${horizontal ? "max-h-52 flex-1" : "max-h-32"} space-y-1 overflow-y-auto pr-1 text-xs`}
      >
        {data.map((item, index) => {
          const selected = selectedId === item.id;
          const className = `flex w-full items-center gap-2 rounded px-2 py-1 text-left ${
            onSelect
              ? "cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"
              : ""
          } ${selected ? "bg-sky-50 dark:bg-sky-900/30" : ""}`;
          const content = (
            <>
              <span
                className="h-2.5 w-2.5 flex-shrink-0 rounded-sm"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              />
              <span className="flex-1 truncate" title={item.name}>
                {item.name}
              </span>
              <strong>{item.value}</strong>
            </>
          );

          return onSelect ? (
            <button
              key={item.id}
              type="button"
              className={className}
              aria-pressed={selected}
              onClick={() => onSelect(selected ? null : item.id)}
            >
              {content}
            </button>
          ) : (
            <div key={item.id} className={className}>
              {content}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DefectCodesChart;
